<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pQFiEn/tc-custom/9781504055741.jpg?1736616960514" alt="This image is the cover for the book Please Don't Eat the Daisies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Please Don't Eat the Daisies
      </h1>
      <p class="bookDescription body article font2">
        <b>The “refreshing . . . laugh-out-loud” #1 <i>New York Times</i> bestseller about life in the suburbs that was adapted into a classic film comedy (<i>Kirkus Reviews</i>).</b><br/>  <br/> One day, Tony Award–winning playwright Jean Kerr packed up her four kids (and husband, Walter, one of Broadway’s sharpest critics), and left New York City. They moved to a faraway part of the world that promised a grassy utopia where daisies grew wild and homes were described as neo-gingerbread. In this collection of “wryly observant” essays, Kerr chronicles her new life in this strange land called Larchmont (<i>The</i><i>Washington Post</i>).<br/>  <br/> It sounds like bliss—no more cramped apartments and nightmarish after-theater cocktail parties where the martinis were never dry enough. Now she has her very own washer/dryer, a garden, choice seats at the hottest new third-grade school plays (low overhead but they’ll never recoup their losses), and a fresh new kind of lunacy.<br/>  <br/> In <i>Please Don’t Eat the Daisies</i> “Jean Kerr cooks with laughing gas” as she explores the everyday absurdities, anxieties, and joys of marriage, family, friends, home decorating, and maintaining a career—but this time with a garage! (<i>Time</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean Kerr
      </h2>
      
      <p class="authorDescription body article">Jean Kerr (1922&ndash;2003) was an Irish-American author and playwright born in Scranton, Pennsylvania, and best known for her humorous bestseller, <I>Please Don&rsquo;t Eat the Daisies</I>, and the plays <I>King of Hearts</I> and <I>Mary, Mary</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0de13616